import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { BottomSheet, Button, Input } from '@netexknowledge/smart-components';

const stopPropagation = event => event.stopPropagation();

const EditNameSheet = ({ open, title, initialValue, maxLength, onSave, onClose }) => {
  const [value, setValue] = useState(initialValue || '');

  useEffect(() => {
    if (open) {
      setValue(initialValue || '');
    }
  }, [open, initialValue]);

  const trimmed = value.trim();
  const canSave = trimmed.length > 0 && trimmed.length <= maxLength;

  const save = () => {
    if (canSave) {
      onSave(trimmed);
    }
  };

  return (
    <span
      className="edit-name-sheet"
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onTouchStart={stopPropagation}
    >
      <BottomSheet
        open={open}
        onClose={onClose}
        closeLabel={I18n.t('common.close')}
        closePlacement="start"
        title={title}
        footer={
          <>
            <Button label={I18n.t('common.cancel')} onClick={onClose} />
            <Button primary label={I18n.t('common.option.save')} disabled={!canSave} onClick={save} />
          </>
        }
      >
        <Input
          id="edit-name-sheet-input"
          label={I18n.t('mobileSheets.name')}
          type="text"
          value={value}
          maxLength={maxLength}
          showCounter
          autoFocus
          onChange={event => setValue(event.target.value)}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              event.preventDefault();
              save();
            }
          }}
        />
      </BottomSheet>
    </span>
  );
};

EditNameSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default EditNameSheet;
